import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 20v-16","key":"svg-0"}],["path",{"d":"M17 4v16","key":"svg-1"}],["path",{"d":"M20 4h-16","key":"svg-2"}]]

/**
 * IconMathPi
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbWF0aC1waSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyAyMHYtMTYiIC8+CiAgPHBhdGggZD0iTTE3IDR2MTYiIC8+CiAgPHBhdGggZD0iTTIwIDRoLTE2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/math-pi
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconMathPi = createReactComponent('outline', 'math-pi', 'MathPi', __iconNode);

export default IconMathPi;